/**
 * @extends storeLocator.StaticDataFeed
 * @constructor
 */
function AjiriDataSource() {
  $.extend(this, new storeLocator.StaticDataFeed);

  var that = this;
  $.get('https://cdn.shopify.com/s/files/1/1160/9706/files/store-locations.csv?6387227157976218371', function(data) {
    that.setStores(that.parse_(data));
  });
}

/**
 * @const
 * @type {!storeLocator.FeatureSet}
 * @private
 */
/**AjiriDataSource.prototype.FEATURES_ = new storeLocator.FeatureSet(
  new storeLocator.Feature('Wheelchair-YES', 'Wheelchair access'),
  new storeLocator.Feature('Audio-YES', 'Audio')
);*/

/**
 * @return {!storeLocator.FeatureSet}
 */
AjiriDataSource.prototype.getFeatures = function() {
  return this.FEATURES_;
};

var geocoder = new google.maps.Geocoder();

AjiriDataSource.prototype.getLatLng = function(address, f) {    
  setTimeout(function() {
  geocoder.geocode({'address': address}, function(results, status) {
    if (status === google.maps.GeocoderStatus.OK) {      
      f("OK", results[0].geometry.location);      
    } else {
      f("Error", status);	
    }
  });
  
  }, 0);
  return -1;
}	  

/**
 * @private
 * @param {string} csv
 * @return {!Array.<!storeLocator.Store>}
 */
AjiriDataSource.prototype.parse_ = function(csv) {
  var stores = [];
  console.dir(stores);
  var rows = csv.split('\n');
  var jsonObj = [];
  var headers = rows[0].split(',');

  for(var i = 1; i < rows.length-1; i++) {
    var data = rows[i].split(',');
    var obj = {};
    for(var j = 0; j < data.length; j++) {
      obj[headers[j].trim()] = data[j].trim();
    }
    
    jsonObj.push(obj);
  }
     
  
  var store;
  var that = this;
  jsonObj.forEach(function(item, index) {    
  	var reqAddress = that.join_([item.Address, item.City, item.State, item.Zip], ', ');    
    var displayLoc = that.join_([item.City, item.State, item.Zip], ', ')
    var displayAddress = that.join_([item.Address, displayLoc], '<br>')
    
    var position = new google.maps.LatLng(item.Lat, item.Lng);
    console.log(item.Name + ": " + item.Lat + " " + item.Lng)
    
    store = new storeLocator.Store(item.ID, position, null, {
          title: item.Name,
          address: displayAddress
    });

    stores.push(store);
    
   
 
  }); 
  
  
    
  
  
  return stores;
};

/**
 * Joins elements of an array that are non-empty and non-null.
 * @private
 * @param {!Array} arr array of elements to join.
 * @param {string} sep the separator.
 * @return {string}
 */
AjiriDataSource.prototype.join_ = function(arr, sep) {
  var parts = [];
  for (var i = 0, ii = arr.length; i < ii; i++) {
    arr[i] && parts.push(arr[i]);
  }
  return parts.join(sep);
};

/**
 * Very rudimentary CSV parsing - we know how this particular CSV is formatted.
 * IMPORTANT: Don't use this for general CSV parsing!
 * @private
 * @param {string} row
 * @return {Array.<string>}
 */
AjiriDataSource.prototype.parseRow_ = function(row) {
  // Strip leading quote.
  if (row.charAt(0) == '"') {
    row = row.substring(1);
  }
  // Strip trailing quote. There seems to be a character between the last quote
  // and the line ending, hence 2 instead of 1.
  if (row.charAt(row.length - 2) == '"') {
    row = row.substring(0, row.length - 2);
  }

  row = row.split('","');

  return row;
};

/**
 * Creates an object mapping headings to row elements.
 * @private
 * @param {Array.<string>} headings
 * @param {Array.<string>} row
 * @return {Object}
 */
AjiriDataSource.prototype.toObject_ = function(headings, row) {
  var result = {};
  for (var i = 0, ii = row.length; i < ii; i++) {
    result[headings[i]] = row[i];
  }
  return result;
};